import { SafeHtml, SafeScript, SafeStyle } from '@angular/platform-browser'

export class ChtmModel {

    constructor() { }

    id: string
    tit: string
    htm: string
    css: string
    js: string
    cmp: number // (1).normal, 2.panel, 3.nav, 4.modal
    srt: number

    dat: any // any structure data
    shtm: SafeHtml
    sjs: SafeScript
    ssty: SafeStyle
    sql: boolean
}